angular.module('NiacsProjectApp.reporting',[
    'NiacsProjectApp.filters',
    'NiacsProjectApp.services-strategy'
])
.directive('niacsProjectReportApp',['$filter','NiacsProject','NiacsVulnAssmntRegion','NiacsStrategyService',function($filter,NiacsProject,NiacsVulnAssmntRegion,NiacsStrategyService){
    var step1Completeness = $filter('step1Completeness'),
        step2Completeness = $filter('step2Completeness'),
        step3Completeness = $filter('step3Completeness'),
        step4Completeness = $filter('step4Completeness'),
        step5Completeness = $filter('step4Completeness'),
        countVulnerabilityDeterminations = $filter('countVulnerabilityDeterminations'),
        dateView = (function(f){
            return function(v) {
                return f(v,'MM/dd/yyyy');
            };
        })($filter('date'));
    function completeness(c) {
        return c === 'partialComplete' ? 'partial' : c;
    }
    function objectivesEvaluated(p) {
        return niacs.collectObjectives(p,true).reduce(function(cnt,o){
            return cnt + (!niacs.isEmptyObject(o.evaluate) ? 1 : 0);
        },0);
    }
    function applicableTactics(p) {
        return niacs.collectObjectives(p,true).reduce(function(ids,o){
            (o.tactics||[]).forEach(function(t){
                if(ids.indexOf(t.id) === -1) {
                    ids.push(t.id);
                }
            });
            return ids;
        },[]).length;
    }
    function objectivesWithMonitoringVars(p) {
        return niacs.collectObjectives(p,true).reduce(function(cnt,o){
            return cnt + (o.monitor && o.monitor.length ? 1 : 0);
        },0);
    }
    function monitoringVars(p) {
        return niacs.collectObjectives(p,true).reduce(function(ids,o){
            (o.monitor||[]).forEach(function(t){
                if(ids.indexOf(t.id) === -1) {
                    ids.push(t.id);
                }
            });
            return ids;
        },[]).length;
    }
    return {
        restrict: 'C',
        template: '<fa-icon ng-if="loading" icon="spinner" class="fa-3x niacs-right" classes="fa-spin"></fa-icon><report-csv-table data="data" view-formatters="viewFormatters"></report-csv-table>',
        link: function($scope) {
            var limit = 50,
                offset = 0,
                sectors = {};
            $scope.viewFormatters = {
                created: dateView,
                changed: dateView
            };
            $scope.data = [];
            $scope.loading = true;
            // pull in more stuff on related entities for project than is by default
            var projectQueryParams = {
                'page[limit]': limit,
                'fields[node--niacs_vuln_assmnt_region]': 'drupal_internal__nid,title',
                'fields[user--user]': 'mail,field_user_fullname,field_user_organization,field_user_contact'
            };
            function next_page() {
                projectQueryParams['page[offset]'] = offset;
                NiacsProject.query(projectQueryParams,function(response) {
                    response.list
                        .forEach(function(p){
                            // don't try to migrate the project if there was an error populating the project.
                            if(!p.$populateError) {
                                try {
                                    var migResults = niacs.migrateProject(p);
                                    /*if(migResults) {
                                        console.log('migrated '+p.label,migResults);
                                    }*/
                                } catch (e) {
                                    console.log('migration error for project',p,e);
                                    //return console.error(e.message); // skip
                                    p.$migrationError = e;
                                }
                            }

                        var d = {
                            // pass any errors along so the table can style problem rows.
                            $error: p.$populateError||p.$migrationError,
                            step_1: completeness(step1Completeness(p,'ab')),
                            units: (p.units||[]).length,
                            goals: niacs.countGoals(p,true),
                            objectives: niacs.countObjectives(p,true),
                            step_2: completeness(step2Completeness(p,'ab')),
                            climate_impacts: niacs.countClimateImpacts(p,true),
                            vulnerabilities: countVulnerabilityDeterminations(p),
                            step_3: completeness(step3Completeness(p,true)),
                            objectives_evaluated: objectivesEvaluated(p),
                            step_4: completeness(step4Completeness(p)),
                            applicable_tactics: applicableTactics(p),
                            step_5: completeness(step5Completeness(p,true)),
                            objectives_with_monitoring_vars: objectivesWithMonitoringVars(p),
                            monitoring_vars: monitoringVars(p),
                            created: p.created ? new Date(p.created) : undefined,
                            changed: p.changed ? new Date(p.changed) : undefined,
                            label: p.label,
                            acres: p.acres,
                            state: p.state_name,
                            sectors: !!p.strategy_sources ? p.strategy_sources.map(function(s){
                                    return sectors[s];
                                }).join(',') : '?',
                            lat: p.lat,
                            lon: p.lon,
                            ownership: p.ownership_name,
                            var: p.$jsonApi.relatedAttribute('field_proj_var_ref','title'),
                            course_project: p.training && p.training.course ? true : false,
                            email: p.author,
                            name: p.$jsonApi.relatedAttribute('uid','field_user_fullname'),
                            organization: p.$jsonApi.relatedAttribute('uid','field_user_organization'),
                            contactable: p.$jsonApi.relatedAttribute('uid','field_user_contact')
                        };
                        $scope.data.push(d);
                    });
                    if($scope.loading = response.list.length === limit) {
                        offset += limit;
                        next_page();
                    }
                });
            }
            NiacsStrategyService.getSources().then(function(sources){
                sectors = sources.reduce(function(map,s){
                    map[s.getSource()] = s.getSourceTitle();
                    return map;
                },{});
                next_page();
            });
        }
    };
}])
.filter('unsnake',[function() {
    return function(s) {
        if(s) {
            s = s.replace(/_/g,' ');
            if(/^[a-z]/.test(s)) {
                s = s.charAt(0).toUpperCase()+s.substring(1);
            }
            return s;
        }
    };
}])
.directive('downloadCsv',['$filter',function($filter){
    var dateFmt = (function(f){
        return function(v) {
            return f(v,'MM/dd/yyyy');
        };
    })($filter('date'));
    return {
        restrict: 'E',
        template: '<a href ng-click="download()" uib-tooltip="Download as CSV" tooltip-placement="left"><fa-icon icon="download"></fa-icon></a>"',
        replace: true,
        scope: {
            data: '='
        },
        link: function($scope) {
            $scope.download = function() {
                var data = $scope.data,
                    keys = Object.keys(data[0]).filter(function(k) { return k.charAt(0) !== '$'; }),
                    rows = [keys];
                data.forEach(function(d){
                    rows.push(keys.reduce(function(row,key){
                        var v = d[key],
                            vt = typeof(v);
                        if(vt !== 'undefined') {
                            if(v instanceof Date) {
                                v = dateFmt(v);
                            } else if(vt === 'boolean') {
                                v = v ? 'TRUE' : 'FALSE';
                            } else if(vt === 'string') {
                                if(/[\r\n",]/.test(v)) {
                                    v = '"'+v.replace(/"/g,'""')+'"';
                                }
                            }
                        } else {
                            v = '';
                        }
                        row.push(v);
                        return row;
                    },[]));
                });
                //console.log('rows',rows);
                var csvContent = rows.reduce(function(content,row){
                    return content+row.join(',')+'\n';
                },'');
                var blob = new Blob([csvContent], { type: 'data:text/csv;base64' });
                var url  = window.URL.createObjectURL(blob);
                //console.log('csvContent',csvContent);
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download','projects.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };
        }
    };
}])
.directive('reportCsvTable',[function(){
    return {
        restrict: 'E',
        scope: {
            data: '=',
            viewFormatters: '=',
        },
        template:
        '<div class="view-count">Displaying {{viewData.length}}/{{data.length}} <download-csv ng-if="viewData.length" data="viewData"></download-csv></div>'+
        '<report-csv-table-filter-controls></report-csv-table-filter-controls>'+
        '<table class="table table-condensed table-striped table-bordered">'+
        '<thead><tr><th ng-repeat="k in keys" sort-on="{{k}}">{{k | unsnake}}</th></tr></thead><tbody>'+
        '<tr ng-repeat="d in viewData" ng-class="{error: !!d.$error}"><td ng-repeat="k in keys">{{viewFormat(k,d[k])}}</td></tr>'+
        '</tbody></table>',
        link: function($scope) {
            $scope.viewFormat = function(key,value) {
                return ($scope.viewFormatters && $scope.viewFormatters[key]) ? $scope.viewFormatters[key](value) : value;
            };
            $scope.$watch('data.length',function(length) {
                var data = $scope.data;
                if(!$scope.keys && data && length) {
                    $scope.keys = Object.keys(data[0]).filter(function(k) {
                        return k.charAt(0) !== '$';
                    });
                }
            });
        }
    };
}])
.directive('reportCsvTableFilterControls',['$filter',function($filter){
    return {
        restrict: 'E',
        template:
        '<form class="form-inline">'+
        '<div class="form-group"><label for="column" class="sr-only">Column</label>'+
        '<select name="column" class="form-control" ng-model="filterSelection.column" ng-options="v as v.label for v in columnInfo"></select></div>'+
        '<span ng-switch="filterSelection.column.type">'+
        '<div ng-switch-when="number" class="form-group">'+
            '<select class="form-control" ng-model="filterSelection.operator" ng-options="o for o in [\'equals\',\'does not equal\',\'greater than\',\'less than\']"></select>'+
            '<input class="form-control" type="number" ng-model="filterSelection.value" />'+
        '</div>'+
        '<div ng-switch-when="string" class="form-group"> '+
            '<select class="form-control" ng-model="filterSelection.operator" ng-options="o for o in [\'equals\',\'does not equal\',\'contains\',\'does not contain\']"></select>'+
            '<input class="form-control" type="text" ng-model="filterSelection.value" placeholder="text" />'+
        '</div>'+
        '<div ng-switch-when="boolean" class="radio"><span class="operator-descriptor">is</span>'+
            '<label><input name="filterBool" type="radio" ng-model="filterSelection.value" ng-value="booleans.t" /> true</label>'+
            '<label><input name="filterBool" type="radio" ng-model="filterSelection.value" ng-value="booleans.f" /> false</label>'+
        '</div>'+
        '<div ng-switch-when="date" class="form-group">'+
            '<select class="form-control" ng-model="filterSelection.operator" ng-options="o for o in [\'after\',\'before\']"></select>'+
            '<input type="text" class="form-control" id="pDate" uib-datepicker-popup="MM/dd/yyyy" placeholder="MM/dd/yyyy" '+
            'ng-focus="filterSelection.$$datePickerOpen=true" is-open="filterSelection.$$datePickerOpen" '+
            'ng-model="filterSelection.value" close-text="Close"/>'+
        '</div>'+
        '</span>'+
        '<button class="btn btn-default add-filter" ng-click="addToFilter()" ng-disabled="filterSelectionHasNoValue()" uib-tooltip="Add filter" tooltip-placement="right"><fa-icon icon="plus"></fa-icon></button>'+
        '</form><!--pre>filter={{filter | json}}\nfilterSelection={{filterSelection | json}}</pre-->'+
        '<div class="badge" ng-repeat="f in filter.values">{{renderFilter(f)}} <a href ng-click="dropFilter(f)"><fa-icon icon="times"></fa-icon></a></div>',
        link: function($scope) {
            $scope.booleans = { t: true, f: false };
            $scope.filter = {};
            $scope.filterSelection = {};
            $scope.filterSelectionHasNoValue = function() {
                return typeof($scope.filterSelection.value) === 'undefined';
            };
            $scope.addToFilter = function() {
                $scope.filter.values = $scope.filter.values||[];
                $scope.filter.values.push($scope.filterSelection);
                $scope.filterSelection = {
                    column: $scope.columnInfo[0]
                };
            };
            $scope.renderFilter = function(f) {
                return [f.column.label,f.operator,(f.value instanceof Date ? $filter('date')(f.value,'MM/dd/yyyy') : f.value)].join(' ');
            };
            $scope.dropFilter = function(f) {
                var idx = $scope.filter.values.indexOf(f);
                if(idx !== -1) {
                    $scope.filter.values.splice(idx,1);
                }
            };
            function reviewColumns() {
                if($scope.columnInfo) {
                    return;
                }
                var unsnake = $filter('unsnake'),
                    data = $scope.data,
                    keys = $scope.keys,i,info;
                function assignTypes(d) {
                    keys.forEach(function(k) {
                        var v = d[k],
                            l = unsnake(k),
                            dt = typeof(v);
                        if(dt !== 'undefined') {
                            if(v instanceof Date) {
                                info[k] = {column: k, label: l, type: 'date'};
                            } else if (dt === 'string' || dt === 'number' || dt === 'boolean') {
                                info[k] = {column: k, label: l, type: dt};
                            }
                        }
                    });
                }
                if((keys = $scope.keys) && data && data.length) {
                    // run forward until we can determine the types of all keys
                    info = {};
                    i = 0;
                    while(Object.keys(info).length < keys.length && i < data.length) {
                        assignTypes(data[i++]);
                    }
                    $scope.columnInfo = Object.keys(info).map(function(k){ return info[k];});
                    $scope.filterSelection.column = $scope.columnInfo[0];
                }
            }
            $scope.$watch('data.length',function() {
                reviewColumns();
                filterData();
            });
            $scope.$watch('keys',reviewColumns);
            $scope.$watch('filterSelection.column',function(c){
                var fs = $scope.filterSelection;
                delete fs.value;
                if(c) {
                    switch(c.type) {
                        case 'boolean':
                            fs.value = true;
                            fs.operator = 'equals';
                            break;
                        case 'string':
                            fs.operator = 'equals';
                            break;
                        case 'number':
                            fs.operator = 'greater than';
                            break;
                        case 'date':
                            fs.operator = 'after';
                            break;
                    }
                }
            });
            function filterData() {
                var viewData = $scope.data;
                ($scope.filter.values||[]).forEach(function(fv){
                    var column = fv.column,
                        op = fv.operator,
                        value = fv.value instanceof Date ? fv.value.getTime() : fv.value,
                        value_lower = typeof(value) === 'string' ? value.toLowerCase() : undefined;
                    viewData = viewData.filter(function(d){
                        var v = d[column.column];
                        if(op === 'equals') {
                            return v === value;
                        }
                        if(op === 'does not equal') {
                            return v !== value;
                        }
                        if(op === 'contains') {
                            return v && v.toLowerCase().indexOf(value_lower) !== -1;
                        }
                        if(op === 'does not contain') {
                            return !v || v.toLowerCase().indexOf(value_lower) === -1;
                        }
                        // must be greater than or less than
                        if(v instanceof Date) {
                            v = v.getTime();
                        }
                        if(op === 'greater than' || op === 'after') {
                            return v > value;
                        }
                        if(op === 'less than' || op === 'before') {
                            return v < value;
                        }
                        // ???
                    });
                });
                viewData = $filter('orderBy')(viewData,$scope.filter.sortOn);
                $scope.viewData = viewData;
            }
            $scope.$watch('filter.sortOn',filterData);
            $scope.$watch('filter.values.length',filterData);
        }
    };
}])
.directive('sortOn',['$log',function($log) {
    var template = '<div class="sort-on" style="display: inline-block; margin-left: 5px; width: 9px;">';
    template += '<i class="'+niacs.FA_PREFIX+' fa-sort-amount-up"></i>';
    template += '<i class="'+niacs.FA_PREFIX+' fa-sort-amount-down"></i>';
    template += '</div>';
    return {
        restrict: 'A',
        link: function($scope,$element,$attrs) {
            $attrs.$observe('sortOn',function(sortOn){
                if($scope.filter && sortOn) {
                    var sortOnAsc = sortOn,
                        sortOnDesc = '-'+sortOn;
                    $element.append(template);
                    $element.css('cursor','pointer');
                    $element.bind('click',function(e){
                        $scope.$apply(function(){
                            switch($scope.filter.sortOn) {
                                case sortOnAsc:
                                    $scope.filter.sortOn = sortOnDesc;
                                    break;
                                case sortOnDesc:
                                    $scope.filter.sortOn = sortOnAsc;
                                    break;
                                default:
                                    $scope.filter.sortOn = sortOnAsc;
                                    break;
                            }
                        });
                    });
                    $scope.$watch('filter.sortOn',function(sortOn) {
                        $element.find('.sort-on i').css('display','none');
                        $element.find('.sort-on svg').css('display','none');
                        if(sortOn === sortOnAsc) {
                            $element.find('.sort-on svg.fa-sort-amount-up').css('display','inherit');
                        } else if (sortOn === sortOnDesc) {
                            $element.find('.sort-on svg.fa-sort-amount-down').css('display','inherit');
                        }
                    });
                }
            });


        }
    };
}]);
